<div class="modal-container">

  <div class="modal-header">
    <h2>Log de exclusão de laudos</h2>

    <button
      type="button"
      class="btn-close"
      (click)="fechar()">
      ✕
    </button>
  </div>

  <div class="modal-content">

    <table class="log-table" *ngIf="logs.length; else semDados">
      <thead>
        <tr>
          <th>ID da vistoria</th>
          <th>Usuário</th>
          <th>Data e hora</th>
          <th>Status</th>
          <th>Mensagem</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let log of logs">
          <td>{{ log.inspectionId }}</td>
          <td>{{ log.userName }}</td>
          <td>{{ log.dateRegister | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>
            <span
              class="status-pill"
              [class.success]="log.status"
              [class.error]="!log.status">
              {{ log.status ? 'SUCESSO' : 'ERRO' }}
            </span>
          </td>
          <td>{{ log.message }}</td>
        </tr>
      </tbody>
    </table>

    <ng-template #semDados>
      <div class="empty">
        Nenhum registro encontrado.
      </div>
    </ng-template>

    <div class="modal-footer" *ngIf="logs.length">
      <a
        href="javascript:void(0)"
        class="export-link"
        (click)="exportCsv()">
        Exportar
      </a>
    </div>

  </div>
</div>
